import { render, staticRenderFns } from "./FaPhotoGallery.vue?vue&type=template&id=ee1e4a68&scoped=true&"
import script from "./FaPhotoGallery.vue?vue&type=script&lang=js&"
export * from "./FaPhotoGallery.vue?vue&type=script&lang=js&"
import style0 from "./FaPhotoGallery.vue?vue&type=style&index=0&id=ee1e4a68&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "ee1e4a68",
  null
  
)

component.options.__file = "FaPhotoGallery.vue"
export default component.exports